import { createStore, applyMiddleware, compose } from 'redux';
import { routerMiddleware } from 'react-router-redux';
import thunk from 'redux-thunk';
import reducers from './reducers';
import environment from 'environment';

const { __DEVELOPMENT__, __CLIENT__, __DEVTOOLS__ } = environment;

export default function create(client, browserHistory, data) {
  const middleware = [
    thunk.withExtraArgument(client),
    routerMiddleware(browserHistory),
  ];
  let finalCreateStore;
  if (__DEVELOPMENT__ && __CLIENT__ && __DEVTOOLS__) {
    const { persistState } = require('redux-devtools');
    const DevTools = require('../../../src/containers/devtools/devtools')
    const composeEnhancers = typeof window === 'object' &&
      window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
      window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__() : compose;


      finalCreateStore = compose(
        applyMiddleware(...middleware),
        persistState(window.location.href.match(/[?&]debug_session=([^&]+)\b/))
      )(createStore);


    // finalCreateStore = composeEnhancers(
    //   applyMiddleware(...middleware),
    //   persistState(window.location.href.match(/[?&]debug_session=([^&]+)\b/))
    // )(createStore);
  } else {
    finalCreateStore = applyMiddleware(...middleware)(createStore);
  }

  const store = finalCreateStore(reducers, data);

  if (__DEVELOPMENT__ && module.hot) {
    module.hot.accept('./reducers', () => {
      store.replaceReducer(require('./reducers'));
    });
  }
  return store;
}
